import { useNavigationStore, useSelectedSolution } from '@store';

export const useHasSelectedPremiumSolution = (): boolean => {
	const { flow } = useNavigationStore();
	const solutionSelected = useSelectedSolution();

	return (flow === 'integratedSolution' && solutionSelected?.id === '201') || false;
};
